import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiAutomatedActionSharingItemsListComponent } from './action-sharing-items-list-dialog/action-sharing-items-list.component';
import { FiAutomatedActionListItemComponent } from './action-list-item.component';
import { FiAutomatedActionSharingItemsListDialogComponent } from './action-sharing-items-list-dialog/action-sharing-items-list-dialog.component';

@NgModule({
    imports: [CommonModule, InfoIconModule, FiAppTextSharedModule, FiIconTooltipButtonModule, FiProfileIconModule],
    declarations: [
        FiAutomatedActionListItemComponent,
        FiAutomatedActionSharingItemsListComponent,
        FiAutomatedActionSharingItemsListDialogComponent,
    ],
    exports: [
        FiAutomatedActionListItemComponent,
        FiAutomatedActionSharingItemsListComponent,
        FiAutomatedActionSharingItemsListDialogComponent,
    ],
})
export class FiAutomatedActionListItemModule {}
